import { useState } from "react"

import { signIn } from "next-auth/react"

import { Button } from "components/Button"

import type { IconName } from "@fortawesome/fontawesome-svg-core"
import type { NextAuthProviders, SignInFormType } from "pages/sign-in"

const SignInOAuth: React.FC<{
  providers: NextAuthProviders
  variant?: Omit<SignInFormType, "forgotPassword">
}> = ({ providers, variant = "signIn" }) => {
  const [clickedOauthButton, setClickedOauthButton] = useState(false)

  return (
    <>
      {Object.values(providers).map(provider =>
        provider.type === "oauth" && provider.id !== "google-calendar" ? (
          <Button
            icon={
              clickedOauthButton
                ? "spinner-third"
                : provider.id === "google-sign-in"
                ? "google"
                : (provider.id as IconName)
            }
            iconLibrary={clickedOauthButton ? "solid" : "brands"}
            iconSpin={clickedOauthButton}
            key={provider.id}
            kind="submit"
            variant="outlineBlack"
            onClick={() => {
              setClickedOauthButton(true)
              signIn(provider.id, {
                redirect: false
              })
            }}
          >
            {variant === "signUp" ? "Sign up" : "Sign in"} with {provider.name}
          </Button>
        ) : null
      )}
    </>
  )
}

export default SignInOAuth
